import React, { useState } from "react";

import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import opacity from "react-element-popper/animations/opacity"

// styles
import styles from "./ConsultantSignupForm.module.css"

const BirthDatepicker = (props) => {
    const [openMenu, setOpenMenu] = useState(false);

    const handleChange = async (value) => {
        props.setConsultantInfo((prev) => {
            return { ...prev, birthDate: value, dateChanged: true };
        });
        if (openMenu === true) {
            setOpenMenu(false)
        }
    }

    return (
        <>
            <style type="text/css">
                {`
                .rmdp-container {
                    width: calc(100% - 3rem);
                    height: 48px !important;
                    background: #ffffff;
                    border: 1px solid #e1e1e1;
                    border-radius: 24px;
                    display: flex !important;
                    align-items: center;
                    justify-content: start;
                    padding-right: 27px;
                    cursor: pointer;
                }
    
                .rmdp-wrapper {
                    width: 100%;
                    background: #FFFFFF !important;
                    border: 1px solid #E1E1E1 !important;
                    border-radius: 24px !important;
                    box-shadow: none !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .rmdp-input,
                .rmdp-input:focus {
                    width: 100%;
                    background: transparent;
                    border: none !important;
                    cursor: pointer !important;
                    box-shadow: none !important;
                }

                rmdp-top-class {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    justify-content: center;
                }
                
                .rmdp-calendar {
                    width: 100%;
                }
                
                .rmdp-day-picker {
                    justify-content: center;
                }
                
                .rmdp-week, .rmdp-ym {
                    width: 100%;
                    padding: 0 27px;
                }

                @media only screen and (max-width: 768.98px) {
                    .rmdp-container {
                      width: 100% !important;
                    }
                  }
    `}
            </style>

            <div className={`w-50 d-flex flex-column align-items-start justify-content-center my-md-0 my-2 ${styles.input_container}`}>
                <div className={`mb-2 ${styles.input_title}`}>
                    تاریخ تولد
                </div>
                <DatePicker
                    value={props.date}
                    onChange={handleChange}
                    animations={[opacity()]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                />
            </div>
        </>
    );
};

export default BirthDatepicker;